import { Ass_06, Inc_07 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const OUTGOING_EU_INVOICE: Template = {
  id: "e33e644e-28fa-4314-87c9-3920950996ff",
  name: "Müügiarve KM-ta (EU)",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Invoice date",
      type: "date"
    },
    {
      name: "Sales amount",
      type: "amount_eur"
    }
  ],
  generate: (values) => {
    const invoiceDate = findVariableValue("Invoice date", values);
    const salesAmount = Math.round(parseFloat(findVariableValue("Sales amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Arve esitamine",
          date: invoiceDate,
          amount: salesAmount,
          eurAmount: salesAmount,
          currency: "eur",
          debit: Ass_06,
          credit: Inc_07
        }
      ]
    };

    return { type: "success", entry };
  }
};
